import { render, staticRenderFns } from "./DocumentUploadModal.vue?vue&type=template&id=1572e69e"
import script from "./DocumentUploadModal.vue?vue&type=script&lang=js"
export * from "./DocumentUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports